/**
 * Заявка на вывод реферального заработка.
 *
 * После успеха перечитывается сводка: доступный баланс уменьшился сразу —
 * сумма зарезервирована, — и экран должен это показать, не дожидаясь
 * обработки заявки администратором.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ApiError, apiPost } from '@/shared/api/client';
import { referralPayoutSchema } from '@/shared/api/schemas';

export type Network = 'usdt_trc20' | 'usdt_ton';

export interface PayoutInput {
  amount_minor: number;
  network: Network;
  address: string;
}

export function payoutErrorText(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.isUnauthorized) return 'Сессия устарела. Закройте и откройте приложение заново.';
    return error.detail;
  }
  return 'Не удалось связаться с сервером. Попробуйте ещё раз.';
}

export function usePayoutRequest() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (input: PayoutInput) => apiPost('/referral/payouts', input, referralPayoutSchema),
    onSuccess: () => client.invalidateQueries({ queryKey: ['referral'] }),
  });
}
